import axios from 'axios';
import { API_URL } from '../config/apiConfig';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Get current onboarding status
export const getOnboardingStatus = async () => {
  try {
    const response = await api.get('/api/onboarding/status');
    return response.data.onboarding;
  } catch (error) {
    console.error('Error fetching onboarding status:', error);
    throw error;
  }
};

// Update organization settings (welcome step)
export const updateOrganizationSettings = async (settings) => {
  try {
    const response = await api.put('/api/onboarding/organization', settings);
    return response.data;
  } catch (error) {
    console.error('Error updating organization settings:', error);
    throw error;
  }
};

// Complete or skip a step
export const updateOnboardingStep = async (step, action = 'complete') => {
  try {
    const response = await api.put('/api/onboarding/step', { step, action });
    return response.data;
  } catch (error) {
    console.error('Error updating onboarding step:', error);
    throw error;
  }
};

// Complete entire onboarding
export const completeOnboarding = async () => {
  try {
    const response = await api.post('/api/onboarding/complete');
    return response.data;
  } catch (error) {
    console.error('Error completing onboarding:', error);
    throw error;
  }
};

const onboardingService = {
  getOnboardingStatus,
  updateOrganizationSettings,
  updateOnboardingStep,
  completeOnboarding,
};

export default onboardingService; 